import { useCallback, useState } from "react";
import { platform } from "@platform/index";

export function usePlatformAuth() {
  const [accessToken, setAccessToken] = useState<string | null>(null);

  const getAccessToken = useCallback(async () => {
    const token = await platform.auth.getAccessToken();
    setAccessToken(token);
    return token;
  }, []);

  return { accessToken, getAccessToken };
}